import { useState } from "react";
import { Check } from "lucide-react";
import { AUDIENCES } from "./data";
import { Section } from "./ui";

export const Audience = () => {
  const [tab, setTab] = useState("msp");
  const a = AUDIENCES[tab];
  return (
    <Section id="pour-qui" over="POUR QUI ?" title="Pensé pour ceux qui maintiennent des PC au quotidien">
      <div className="inline-flex rounded-full border border-slate-800 p-1 mb-10" role="tablist">
        {Object.entries(AUDIENCES).map(([k, v]) => (
          <button key={k} onClick={() => setTab(k)} role="tab" aria-selected={tab === k} data-testid={`audience-tab-${k}`}
            className={`px-5 py-2 rounded-full text-sm font-medium transition-colors ${tab === k ? "bg-sky-500 text-slate-950" : "text-slate-300 hover:text-white"}`}>
            {v.label}
          </button>
        ))}
      </div>
      <div key={tab} className="grid lg:grid-cols-2 gap-10 items-center fade-up" data-testid={`audience-panel-${tab}`}>
        <img src={a.img} alt={a.label} className="rounded-2xl border border-slate-800 aspect-[4/3] object-cover w-full" loading="lazy" />
        <div>
          <h3 className="text-xl sm:text-2xl font-bold mb-6">{a.title}</h3>
          <ul className="space-y-4">
            {a.points.map((p) => (
              <li key={p} className="flex gap-3 text-slate-300"><Check className="h-5 w-5 text-sky-400 flex-shrink-0 mt-0.5" />{p}</li>
            ))}
          </ul>
        </div>
      </div>
    </Section>
  );
};
